<template>
  <div v-if="this.$store.getters.isAdmin">
    <v-tabs
      v-model="selectedTab"
      background-color="pink lighten-2"
      grow
      icons-and-text
      dark
      class="mb-10"
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-themes">
        <p style="font-weight:600">Thèmes</p > 
      </v-tab>
      <v-tab href="#tab-videos">
        <p style="font-weight:600">vidéos</p >
      </v-tab>
      <v-tab href="#tab-courses">
        <p style="font-weight:600">Parcours</p >
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab">
      <v-tab-item value="tab-themes">
        <Themes></Themes>
      </v-tab-item>
      <v-tab-item value="tab-videos">
        <Videos></Videos>
      </v-tab-item>
      <v-tab-item value="tab-courses">
        <Courses></Courses>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<style lang="scss">
  @import "@/assets/sass/pages/error/error-6.scss";
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Videos from "@/components/admin/video/forms/tabs/videos.vue";
import Courses from "@/components/admin/course/forms/tabs/courses.vue";
import Themes from "@/components/admin/theme/forms/tabs/themes.vue";

export default {
  name: "contentManagement",
  components: {
    Videos,
    Courses,
    Themes,
  },
  data: ()=> ({
    selectedTab: null,
  }),
    watch: {
    selectedTab(value) {
      localStorage.selectedTab = value;
    }
  },
  mounted() {
    if (localStorage.selectedTab) {
       this.selectedTab = localStorage.selectedTab;
    } 
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration" },
      { title: "Gestion des contenus" },
    ]);
  },
};
</script>
